import { addStatusToTransactions } from '../../components';
import {
  PageFields_PaymentDetectedPage_Fragment,
  PageFields_UnderpaidPaymentDetectedPage_Fragment,
} from '../../graphql/generated';
import { PaymentPendingProps } from './PaymentPending';

type PaymentPage =
  | PageFields_UnderpaidPaymentDetectedPage_Fragment
  | PageFields_PaymentDetectedPage_Fragment;

function getPageData(data: PaymentPage) {
  return data.__typename === 'PaymentDetectedPage'
    ? data.pageData
    : data.UnderpaidPaymentDetectedPageData;
}

function isUnderpaidPaymentDetectedPage(
  data: PaymentPage
): data is PageFields_UnderpaidPaymentDetectedPage_Fragment {
  return data.__typename === 'UnderpaidPaymentDetectedPage';
}

export const mapPaymentPendingPageData = (
  data: PaymentPage
): PaymentPendingProps => {
  const pageData = getPageData(data);

  const transactions = [
    ...addStatusToTransactions(pageData.detectedTransactions, 'detected'),
    ...(isUnderpaidPaymentDetectedPage(data)
      ? addStatusToTransactions(
          data.UnderpaidPaymentDetectedPageData.confirmedTransactions,
          'confirmed'
        )
      : []),
  ];

  return {
    expiresAt: pageData.expiresAt,
    merchantName: pageData.merchantName || '',
    transactions: transactions,
    blockchain: pageData.blockchain,
    noOfConfirmationBlocks: Number(pageData.noOfConfirmationBlocks),
    billType: pageData.billType || '',
  };
};

const BLOCKCHAIN_BLOCK_KEY = 'blockchain_last_block_';

export const saveBlockchainData = (blockchain: string, blockNumber: number) => {
  if (!blockchain) return;
  localStorage.setItem(
    `${BLOCKCHAIN_BLOCK_KEY}${blockchain}`,
    blockNumber.toString()
  );
};

export const getBlockchainData = (blockchain: string): number | null => {
  if (!blockchain) return null;
  const value = localStorage.getItem(`${BLOCKCHAIN_BLOCK_KEY}${blockchain}`);
  return value ? parseInt(value) : null;
};
